<template>
  <div class="header">
    <div class="container">
      <!-- .header-top start -->
      <div class="header-top">
        <div class="logo">
          <a href="#"><img :src="logo" alt="logo" /></a>
        </div>
        <div class="search_box">
          <form>
            <input type="text" placeholder="Search for Products...">
            <input type="submit" value="search">
          </form>
        </div>
        <div class="header-facilities">

          <div class="header-sm-box login">
            <router-link to="/login"><i class="fa fa-user"></i> Login</router-link>
          </div>

          <div class="header-sm-box shopping_cart">
            <div class="cart">
              <a href="#" title="View my shopping cart" rel="nofollow">
                <span class="cart_title"><i class="fa fa-shopping-cart"></i> Cart</span>
                <span class="no_product">(empty)</span>
              </a>
            </div>
          </div>

          <div class="header-sm-box needhelp">
            <router-link to="/faq"><i class="fa fa-question"></i> need help</router-link>
          </div>

        </div>
      </div>
      <!-- .header-top end -->
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        logo : 'assets/images/logo/logo.png',
        showLogIn : false,
        showCart : false,
        showNeedHelp : false
      }
    }
  }
</script>

